
export default function (Component) {
  Component.options.__source = "src/views/macroDecisionMaking/pmdInfluenceFactora.vue"
}
